// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3M7Z7","title":"styles_title__3NzZJ"};